export enum SurfaceErrors {
  RasterTooBig = 'SLS_RASTER_TOO_BIG',
  TooMuchData = 'SLS_TOO_MUCH_DATA',
  VisualizationFailed = 'SLS_VISUALIZATION_FAILED',
  RefmodelRasterizationFailed = 'SLS_REFMODEL_RASTERIZATION_FAILED',
  NoRastersIntersection = 'SLS_NO_RASTERS_INTERSECTION_FOR_DH_CALC'
}